import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import ErrorBoundary from "./components/ErrorBoundary";
import Dashboard from "./pages/Dashboard";
import RecentLogs from "./pages/RecentLogs";
import Tasks from "./pages/Tasks";
import TaskHistory from "./pages/TaskHistory";
import Reports from "./pages/Reports";
import SettlementDifference from "./pages/SettlementDifference";
import MasterReport from "./pages/MasterReport";
import Employees from "./pages/Employees";
import Inventory from "./pages/Inventory";
import Barcode from "./pages/Barcode";
import ItemHistory from "./pages/ItemHistory";
import Movement from "./pages/Movement";
import Manufacture from "./pages/Manufacture";
import ManufactureHistory from "./pages/ManufactureHistory";
import ManufactureValueSetup from "./pages/ManufactureValueSetup";
import Orders from "./pages/Orders";
import Salary from "./pages/Salary";
import Attendance from "./pages/Attendance";
import AttendanceHistory from "./pages/AttendanceHistory";
import RoleManagement from "./pages/RoleManagement";
import CompareDashboard from "./pages/Compare";
import Purchases from "./pages/Purchases";
import Sales from "./pages/Sales";
import Accounts from "./pages/Accounts";
import Suppliers from "./pages/Suppliers";
import PurchaseHistory from "./pages/PurchaseHistory";
import SalesHistory from "./history/SalesHistory";
import TotalSales from "./pages/TotalSales";
import ProductSale from "./pages/ProductSale";
import SalesOrders from "./pages/SalesOrders";
import SalesDrafts from "./pages/SalesDrafts";
import OpenSales from "./pages/OpenSales";
import Rto from "./pages/Rto";
import ReturnInTransit from "./pages/ReturnInTransit";
import Tracking from "./pages/Tracking";
import CustomerReturns from "./pages/CustomerReturns";
import Login from "./pages/Login";
import Unauthorized from "./pages/Unauthorized";
import ProtectedRoute from "./ProtectedRoute";
import LoginActivity from "./pages/LoginActivity";
import EmployeeActivity from "./pages/EmployeeActivity";
import EmployeeActivityDetail from "./pages/EmployeeActivityDetail";
import SalaryHistory from "./pages/SalaryHistory";
import InventoryHistory from "./history/InventoryHistory";
import PurchaseOrder from "./pages/PurchaseOrder";
import SupplierLedger from "./pages/SupplierLedger";
import SupplierPurchaseHistory from "./pages/SupplierPurchaseHistory";
import NetWorth from "./pages/NetWorth";
import BalanceHistoryPage from "./pages/BalanceHistoryPage";
import Packaging from "./pages/Packaging";
import PackagingHistory from "./pages/PackagingHistory";
import LocationSetting from "./pages/LocationSetting";
import Profile from "./pages/Profile";
import MasterPinPage from "./pages/MasterPinPage";
import Settlement from "./pages/Settlement";
import EmployeePerformance from "./pages/EmployeePerformance";
import ExpenseManagement from "./pages/ExpenseManagement";
import HelpDesk from "./pages/HelpDesk";
import AboutPage from "./pages/AboutPage";
import FeaturesPage from "./pages/FeaturesPage";
import WorkflowPage from "./pages/WorkflowPage";
import Notifications from "./pages/Notifications";
import TeamFeedback from "./pages/TeamFeedback";




function App() {
  
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>

        {/* Dashboard */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Layout>
                <Dashboard />
              </Layout>
            </ProtectedRoute>
          }
        />
<Route
  path="/purchase/history/:supplierId"
  element={
    <ProtectedRoute>
      <Layout>
        <SupplierPurchaseHistory />
      </Layout>
    </ProtectedRoute>
  }
/>

        {/* Pages */}
        <Route
          path="/tasks"
          element={
            <ProtectedRoute>
              <Layout>
                <Tasks />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/task-history/:taskId"
          element={
            <ProtectedRoute>
              <Layout>
                <TaskHistory />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/tasks/history/:employeeId"
          element={
            <ProtectedRoute>
              <Layout>
                <TaskHistory />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
  path="/salary-history"
  element={
    <ProtectedRoute>
      <Layout>
        <SalaryHistory />
      </Layout>
    </ProtectedRoute>
  }
/>
<Route
  path="/purchase/history"
  element={
    <ProtectedRoute>
      <Layout>
        <PurchaseHistory />
      </Layout>
    </ProtectedRoute>
  }
/>
<Route
  path="/supplier-ledger/:supplierId"
  element={
    <ProtectedRoute>
      <Layout>
        <SupplierLedger />
      </Layout>
    </ProtectedRoute>
  }
/>


        <Route
          path="/reports"
          element={
            <ProtectedRoute>
              <Layout>
                <Reports />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route path="/reports/difference" element={<ProtectedRoute><Layout><SettlementDifference /></Layout></ProtectedRoute>} />
        <Route
          path="/recent-logs"
          element={
            <ProtectedRoute>
              <Layout>
                <RecentLogs />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/reports/master"
          element={
            <ProtectedRoute>
              <Layout>
                <MasterReport />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/employees"
          element={
            <ProtectedRoute>
              <Layout>
                <Employees />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/employee-performance"
          element={
            <ProtectedRoute>
              <Layout>
                <EmployeePerformance />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/team-feedback"
          element={
            <ProtectedRoute roles={["admin"]}>
              <Layout>
                <TeamFeedback />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/expense-management"
          element={
            <ProtectedRoute>
              <Layout>
                <ExpenseManagement />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/help-desk"
          element={
            <ProtectedRoute roles={["admin"]}>
              <Layout>
                <HelpDesk />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/notifications"
          element={
            <ProtectedRoute roles={["admin"]}>
              <Layout>
                <Notifications />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/inventory"
          element={
            <ProtectedRoute>
              <Layout>
                <Inventory />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settlement"
          element={
            <ProtectedRoute>
              <Layout>
                <Settlement />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/packaging"
          element={
            <ProtectedRoute>
              <Layout>
                <Packaging />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/packaging/history"
          element={
            <ProtectedRoute>
              <Layout>
                <PackagingHistory />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/inventory/barcode"
          element={
            <ProtectedRoute>
              <Layout>
                <Barcode />
              </Layout>
            </ProtectedRoute>
          }
        />
<Route
  path="/inventory/history/:id"
  element={
    <ProtectedRoute>
      <Layout>
        <ItemHistory />
      </Layout>
    </ProtectedRoute>
  }
/>
<Route
  path="/inventory/history"
  element={
    <ProtectedRoute>
      <Layout>
        <InventoryHistory />
      </Layout>
    </ProtectedRoute>
  }
/>


        <Route
          path="/movement"
          element={
            <ProtectedRoute>
              <Layout>
                <Movement />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/manufacture"
          element={
            <ProtectedRoute>
              <Layout>
                <Manufacture />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/manufacture/history"
          element={
            <ProtectedRoute>
              <Layout>
                <ManufactureHistory />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/manufacture/value-setup"
          element={
            <ProtectedRoute>
              <Layout>
                <ManufactureValueSetup />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/orders"
          element={
            <ProtectedRoute>
              <Layout>
                <Orders />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/salary"
          element={
            <ProtectedRoute>
              <Layout>
                <Salary />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Layout>
                <Profile />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/master-pin"
          element={
            <ProtectedRoute roles={["admin"]}>
              <Layout>
                <MasterPinPage />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/attendance"
          element={
            <ProtectedRoute>
              <Layout>
                <Attendance />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/attendance-history"
          element={
            <ProtectedRoute>
              <Layout>
                <AttendanceHistory />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/location-setting"
          element={
            <ProtectedRoute>
              <Layout>
                <LocationSetting />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/roles"
          element={
            <ProtectedRoute>
              <Layout>
                <RoleManagement />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/compare"
          element={
            <ProtectedRoute>
              <Layout>
                <CompareDashboard />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/purchases"
          element={
            <ProtectedRoute>
              <Layout>
                <Purchases />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/purchases/order"
          element={
            <ProtectedRoute>
              <Layout>
                <PurchaseOrder />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/purchases/supplier-payment"
          element={
            <ProtectedRoute>
              <Layout>
                <Purchases />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/suppliers"
          element={
            <ProtectedRoute>
              <Layout>
                <Purchases />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/purchases/history"
          element={
            <ProtectedRoute>
              <Layout>
                <PurchaseHistory />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
  path="/login-activity"
  element={
    <ProtectedRoute>
      <Layout>
        <LoginActivity />
      </Layout>
    </ProtectedRoute>
  }
/>
        <Route
          path="/employee-activity"
          element={
            <ProtectedRoute roles={["admin", "subadmin"]}>
              <Layout>
                <EmployeeActivity />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/employee-activity/:employeeId"
          element={
            <ProtectedRoute roles={["admin", "subadmin"]}>
              <Layout>
                <EmployeeActivityDetail />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/networth"
          element={
            <ProtectedRoute>
              <Layout>
                <NetWorth />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/networth/balance-history"
          element={
            <ProtectedRoute>
              <Layout>
                <BalanceHistoryPage />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/sales"
          element={
            <ProtectedRoute>
              <Layout>
                <Sales />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/sales/history"
          element={
            <ProtectedRoute>
              <Layout>
                <SalesHistory />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/sales/accounts"
          element={
            <ProtectedRoute>
              <Layout>
                <Accounts />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/sales/total"
          element={
            <ProtectedRoute>
              <Layout>
                <TotalSales />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/sales/product-sale"
          element={
            <ProtectedRoute>
              <Layout>
                <ProductSale />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/sales/orders"
          element={
            <ProtectedRoute>
              <Layout>
                <SalesOrders />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/sales/open-sales"
          element={<ProtectedRoute><Layout><OpenSales /></Layout></ProtectedRoute>}
        />
        <Route
          path="/sales/drafts"
          element={
            <ProtectedRoute>
              <Layout>
                <SalesDrafts />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/rto"
          element={
            <ProtectedRoute>
              <Layout>
                <Rto />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/return-in-transit"
          element={
            <ProtectedRoute>
              <Layout>
                <ReturnInTransit />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/tracking"
          element={
            <ProtectedRoute>
              <Layout>
                <Tracking />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/customer-returns"
          element={
            <ProtectedRoute>
              <Layout>
                <CustomerReturns />
              </Layout>
            </ProtectedRoute>
          }
        />

        {/* Public */}
        <Route path="/login" element={<Login />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/features" element={<FeaturesPage />} />
        <Route path="/workflow" element={<WorkflowPage />} />

        {/* Default */}
        <Route path="/" element={<Navigate to="/login" />} />

        {/* 404 */}
        <Route path="*" element={<h2>404 - Page Not Found</h2>} />
      </Routes>
    </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
